import React from 'react';
import { connect } from 'react-redux';
import { $Menu } from 'styles';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router';
import { getEnabledPrivateRoutes } from 'utils/routeHelpers';
import { matchPropTypes } from 'utils/proptypes';
import V2DashboardBanner from 'components/v2DashboardBanner';
import featureFlags, { FeatureFlags } from 'modules/featureFlags';
import { selectAccounts } from 'modules/accounts';

import Footer from '../Footer';
import MenuLink from '../MenuLink';
import AppProfile from '../AppProfile';
import EnvironmentSection from './EnvironmentSection';
import { $Divider, $MenuLinksContainer } from './styles';
import generateBreadcrumbs from '../BreadCrumbs/generateBreadcrumbs';

const Menu = ({
  appId,
  match,
  scopes,
  appName,
  traits,
  appLogoUrl,
  environment,
  toggleEnvironmentValue,
  isToggleEnvironmentPossible,
  accountsState,
}) => {
  const enabledPrivateRoutes = getEnabledPrivateRoutes({
    appTraits: traits,
    scopes,
    environment,
    appId,
    accountsState,
  });

  const isRolloutDashboardV2Enabled = featureFlags.isOn(
    FeatureFlags.rolloutDashboardV2,
  );

  return (
    <$Menu>
      <AppProfile appLogoUrl={appLogoUrl} appName={appName} />
      <$Divider />

      <EnvironmentSection
        environment={environment}
        toggleEnvironmentValue={toggleEnvironmentValue}
        isToggleEnvironmentPossible={isToggleEnvironmentPossible}
      />
      <$Divider />

      {isRolloutDashboardV2Enabled && <V2DashboardBanner />}

      <$MenuLinksContainer>
        {enabledPrivateRoutes.map(({ icon, label, path }) => {
          // Bit hacky while we get more purpose-built routing
          // If it's an :id based route, swap the id out for first app id
          const generatedPath =
            path.includes(':id') && appId
              ? generatePath(path, {
                  id: appId,
                })
              : path;

          // Keep the menu active even when the user is viewing its children pages
          const crumbs = generateBreadcrumbs(match);
          const isActiveMenu = crumbs.some(
            crumb => crumb.path === generatedPath,
          );

          return (
            <MenuLink
              icon={icon}
              isActive={isActiveMenu}
              key={path}
              path={generatedPath}
            >
              {label}
            </MenuLink>
          );
        })}
      </$MenuLinksContainer>
      <Footer />
    </$Menu>
  );
};

Menu.propTypes = {
  appId: PropTypes.string,
  scopes: PropTypes.arrayOf(PropTypes.string),
  match: matchPropTypes,
  traits: PropTypes.arrayOf(PropTypes.string),
  accountsState: PropTypes.shape({
    accounts: PropTypes.array,
    fetchingAccounts: PropTypes.bool,
  }).isRequired,
  ...AppProfile.propTypes,
};

Menu.defaultProps = {
  appId: '',
  scopes: [],
  traits: [],
  ...AppProfile.defaultProps,
};

const mapStateToProps = state => ({
  accountsState: selectAccounts(state),
});

export default connect(mapStateToProps)(Menu);
